import React, { useContext } from 'react';
import ListItem from '@mui/material/ListItem';
import { Link } from 'react-router-dom';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AppsIcon from '@mui/icons-material/Apps';
import HandshakeIcon from '@mui/icons-material/Handshake';
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';

import { userDetailContext } from '../App';
import { SMQ_PRIVILEGES } from '../constants/smqPrivileges';
import { hasPrivilege } from '../utils/privilege';

const modes = [
    { id: 1, name: 'Mode Administration', link: '/home', icon: <AppsIcon /> },
    { id: 2, name: 'Base de données Partenaire', link: '/partner/dashboard', icon: <HandshakeIcon /> },
    { id: 3, name: 'Non conformité / SMQ', link: '/smq_nc/dashboard', icon: <WarningAmberOutlined /> },
    { id: 4, name: 'Espace Tutoriels', link: '/formation', icon: <AutoStoriesIcon /> },

]

function ListItemLink(props) {
    return <ListItem button component={Link} {...props} />;

}

const ModeList = ({onSelectMode = () => {} }) => {
    const contextData = useContext(userDetailContext);
    const canAccessSmq = hasPrivilege(
        contextData?.privileges || [],
        SMQ_PRIVILEGES.READ
    );
    const visibleModes = modes.filter(
        (mode) => mode.id !== 3 || canAccessSmq
    );

    return (
         <List component="nav" aria-label="main mailbox folders">
            {visibleModes.map((mode) => (
                <ListItemLink
                    key={mode.id}
                    to={mode.link}
                    onClick={() => onSelectMode(mode)}
                >
                    <ListItemIcon>
                        {mode.icon}
                    </ListItemIcon>
                    <ListItemText primary={mode.name} />
                </ListItemLink>
            ))}
        </List>
    );
};

export default ModeList;
